import React, { useState, useEffect } from "react";
import Header2 from "./Header2";
import Filters from "./Filters";
import Cards from "./Cards";
import BarGraph from "./BarGraph";
import LineGraph from "./LineGraph";
import PieCharts from "./PieCharts";
import "./DashboardLayout2.css";
import CustomButton from "./Button2";
const DashboardLayout2 = ({ onLogout }) => {
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({}); // Initialize filters state
  const [lastUpdated, setLastUpdated] = useState(""); // Initialize state for last updated

  useEffect(() => {
    const today = new Date();
    today.setHours(6, 0, 0, 0); // Set the time to 6:00 AM of the current day

    // Format date as "YYYY-MM-DD HH:MM"
    const formattedDate = today.toISOString().slice(0, 16).replace("T", " ");
    setLastUpdated(`Last data updated: ${formattedDate}`);
  }, []);

  return (
    <div className="dashboard-layout-v2">
      {/* Header */}
      <Header2 onLogout={onLogout}/>
      <nav className="header-nav-v2">
        <CustomButton />
        
      </nav>
      {/* Main Dashboard Body */}
      <div className="dashboard-main-v2">
        {/* Filters */}
        <Filters setFilters={setFilters} setFilteredData={setFilteredData} />

        {/* Last updated date */}
       {/* Filters and Info Row */}

       <div className="filters-info-row">
  <div className="last-updated">{lastUpdated}</div>
  {!Object.keys(filters).length && (
    <div className="info-text">* Select above filters to view data..</div>
  )}
</div>



        {/* Cards */}
        <Cards filters={filters} filteredData={filteredData} />

        {/* Graphs and Pie Charts */}
        <div className="dashboard-content-v2">
          <div className="graphs-container-v2">
            <div className="bar-graph-container-v2">
              <BarGraph filters={filters} filteredData={filteredData} />
            </div>
            <div className="line-graph-container-v2">
              <LineGraph filters={filters} filteredData={filteredData} />
            </div>
          </div>
          <div className="pie-charts-container-v2">
            <PieCharts filters={filters} filteredData={filteredData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout2;
